module.exports = __webpack_public_path__ + "static/media/template1.07513ea8.svg";